import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#CBCBDB",
      "fill-opacity": ".9",
      d: "M9.679 2.302a.516.516 0 0 0-.748.055c-.285.356-.593.787-.897 1.28H2.638a.54.54 0 0 0-.538.538v7.695c0 .501.406.908.908.908h5.586c.117.306.243.578.364.806a.5.5 0 0 0 .721.17c.249-.163.318-.497.182-.762a7 7 0 0 1-.105-.214h3.236a.91.91 0 0 0 .908-.908V4.545a.91.91 0 0 0-.908-.907H9.315q.216-.307.421-.566a.563.563 0 0 0-.057-.77M3.176 4.713h4.272c-.036.075-.075.14-.11.217a11.9 11.9 0 0 0-.978 3.499l-.072.6h2.083a6.5 6.5 0 0 0-.18 1.079c-.06-.001-.115.002-.175 0a8.4 8.4 0 0 1-2.622-.513.566.566 0 0 0-.717.29c-.12.271.002.59.28.695a9.4 9.4 0 0 0 3.025.603c.079.003.153-.001.23 0 .009.075.009.144.02.223.014.102.034.199.052.296H3.176zm5.478 0h4.17v6.99H9.381a5 5 0 0 1-.084-.447q-.007-.062-.013-.122c.93-.1 1.707-.325 2.282-.538a.515.515 0 0 0 .283-.694.567.567 0 0 0-.715-.294 8.5 8.5 0 0 1-1.857.442c.054-.601.187-1.09.29-1.375l.26-.721H7.541c.125-.73.327-1.591.776-2.58.107-.236.222-.449.336-.66m1.488 1.097v1.554h1.075V5.81zm-5.381.066V7.4h1.076V5.876z",
      style: {"fill":"color(display-p3 .7976 .7976 .8582)","fill-opacity":".9"}
    }, null, -1)
  ])))
}
export default { render: render }